import { useEffect, useMemo, useState } from "react";
import { sanitizeDecimal } from "../utils/number";

type Args = {
  moneda: string;
  tipoCambio: number;
  setTipoCambio: (n: number) => void;
  MAX_DEC: number;
};

export const useCurrencyTC = ({
  moneda,
  tipoCambio,
  setTipoCambio,
  MAX_DEC,
}: Args) => {
  const [tcInput, setTcInput] = useState<string>("1.000000");
  const parsedTC = useMemo(() => Number(tcInput), [tcInput]);
  const tcInvalido =
    moneda !== "MXN" &&
    (Number.isNaN(parsedTC) || parsedTC <= 0 || parsedTC === 1);

  useEffect(() => {
    if (moneda === "MXN") {
      setTcInput("1.000000");
      setTipoCambio(1);
    } else {
      const v = Number.isFinite(tipoCambio) ? tipoCambio : 0;
      const start = v > 0 && v !== 1 ? v.toFixed(MAX_DEC) : "0";
      setTcInput(start);
      setTipoCambio(v);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moneda]);

  const handleChangeTC = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = sanitizeDecimal(e.target.value, MAX_DEC);
    setTcInput(v);
    const n = v === "" ? NaN : Number(v);
    setTipoCambio(Number.isNaN(n) ? NaN : n);
  };

  const handleBlurTC = () => {
    if (moneda === "MXN") return;
    if (tcInput === "" || Number.isNaN(parsedTC)) {
      setTcInput("0");
      setTipoCambio(0);
      return;
    }
    const fixed = parsedTC.toFixed(MAX_DEC);
    setTcInput(fixed);
    setTipoCambio(parsedTC);
  };

  return {
    tcInput,
    parsedTC,
    tcInvalido,
    handleChangeTC,
    handleBlurTC,
    setTcInput,
  };
};
